// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_47-6";
export var headerCell = "_47-2";
export var rowWrapper = "_47-4";
export var stickyAggregationCell = "_47-a";
export var stickyAggregationRow = "_47-7";
export var stickyColumnCell = "_47-9";
export var stickyColumnHeaderCell = "_47-8";
export var table = "_47-1";
export var virtualRowWrapper = "_47-5";
export var virtualTableContainer = "_47-0";
export var white = "_47-3";